/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as PropTypes from 'prop-types';


export const ProductDetailSKUModelType = {
    materialNumber: PropTypes.string,
    toggleButtonText: PropTypes.string,
    description: PropTypes.string,
    storage: PropTypes.string,
    packaging:  PropTypes.string,
    shelfLife: PropTypes.string,
    palletisation: PropTypes.string,
    orderable: PropTypes.bool,
    extraLabel: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
        empty: PropTypes.bool,
    })),
    empty: PropTypes.bool
};

export const ProductDetailModelType = {
    componentTitle: PropTypes.string,
    productId: PropTypes.string,
    variationsList: PropTypes.arrayOf(PropTypes.shape(ProductDetailSKUModelType))
};
